"use strict";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
// This is needed in GS1 seminar registration forms.
$.gs1_cart = {
    init: function () {
        // probably no init needed!?
        $.gs1_cart.cartButton = $('div#top_cart_button');
        $.gs1_cart.cartAmount = $('em', $.gs1_cart.cartButton);
        if ($('#useBillingAddress').val() != 1) {
            $('#billing-address').hide();
        }
        $('#show-billing').bind({
            click: function () {
                $('#billing-address').slideToggle();
                $('#useBillingAddress').val(1);
                return false;
            }
        });
        $.gs1_cart.initPriceCalculation();
    },
    updateCartButton: function () {
        $.ajax({
            url: '?eID=tx_gs1cart_eid&tx_gs1cart[action]=getNumberOfItemsInCart',
            type: 'POST',
            success: function (data, textStatus, jqXHR) {
                $.gs1_cart.cartAmount.text(data);
            }
        });
    },
    initPriceCalculation: function () {
        $('.table-cart-select select').on('change', function (event) {
            var data = $(this).data();
            if (data.id && data.price && data.tax) {
                var $priceTotal = $('#price-total-' + data.id);
                if ($priceTotal.length > 0) {
                    var price = 0;
                    var selectedValue = $(this).val();
                    price = parseFloat(parseInt(selectedValue) * $.gs1_cart.parseGermanPriceToFloat(data.price));
                    // Create german formatted output
                    var priceParts = price.toFixed(2).split('.');
                    price = priceParts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ',' + priceParts[1];
                    $priceTotal.text(price + ' €');
                }
            }
        });
    },
    /**
     * Convert incoming price in german format (1.000,00) to english format (1,000.00) and vice versa
     *
     * @param priceValue, The value to convert
     * @returns float
     */
    parseGermanPriceToFloat: function (priceValue) {
        var convertedString = priceValue.toString().replace('.', '[dot]');
        convertedString = convertedString.replace(/,/, '.');
        convertedString = convertedString.replace('[dot]', '');
        return parseFloat(convertedString);
    }
};
// Wait until DOM is ready
$(function () {
    // Initiate the cart class
    $.gs1_cart.init();
});
